import Vue from 'vue'
import Vuex from 'vuex'
import Iot from  "./Iot"
import main from "./main"
import production from "./production"
import traceability from "./traceability"
import video from "./video"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
		address: null,
		width: 0,
		height: 0,
		minwidth: 700,
		formload: false,
		mainload: false,
		isphone: false
  },
  mutations: {
		address(state,value)
		{
			state.address=value;
		},
		width(state,value)
		{
			state.width=value;
			state.isphone=value<700;
		},
		height(state,value)
		{
			state.height=value;
		},
		formload(state,value)
		{
			state.formload=value;
		},
		mainload(state,value)
		{
			state.mainload=value;
		}
  },
  actions: {
		
  },
	modules: {
		Iot: Iot.Iot,
		main: main.main,
		production: production.production,
		traceability: traceability.traceability,
		video: video.video
  }
})
